import Client from "../client";
import ConfigurationRepository from "./configurationRepository";
import {SmtpConfigurationResource} from "client/resources";

class SmtpConfigurationRepository extends ConfigurationRepository<SmtpConfigurationResource> {
    constructor(client: Client) {
        super("SmtpConfiguration", client);
    }
}

export default SmtpConfigurationRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/smtpConfigurationRepository.ts